var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isList
    ? _c(
        "div",
        {
          staticClass: "go-card-item",
          attrs: { "data-template": "report", "data-size": "1x2" },
        },
        [
          _c("div", { staticClass: "go-card" }, [
            _c("div", { staticClass: "go-card-body" }, [
              _c("div", { staticClass: "go-card-secondary" }, [
                _c("div", { staticClass: "go-card-img" }, [
                  _vm.report.img
                    ? _c("img", {
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: _vm.report.img },
                        on: {
                          error: function ($event) {
                            _vm.report.img = "content/images/common/AI-img.png"
                          },
                          click: _vm.navigateToDetail,
                        },
                      })
                    : _c("img", {
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: "content/images/common/AI-img.png" },
                        on: { click: _vm.navigateToDetail },
                      }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-card-primary" }, [
                _c(
                  "div",
                  { staticClass: "go-card-content" },
                  [
                    _c("div", { staticClass: "go-block-wrap" }, [
                      _c(
                        "span",
                        { staticClass: "badge badge-secondary title-overflow" },
                        [_vm._v(_vm._s(_vm.report.type) + " ")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "badge badge-text" }, [
                        _c("i", { staticClass: "go-icon-16 go-icon-file" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.report.resourceType)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "go-card-title",
                        attrs: {
                          to: {
                            name: "Detail-report",
                            params: { reportId: _vm.report.id },
                          },
                          custom: "",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.report.title) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "go-card-info" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.report.formattedCreatedAt
                    ? _c("span", { staticClass: "date" }, [
                        _vm._v(_vm._s(_vm.report.formattedCreatedAt)),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-card-action" }, [
                  _c("div", { staticClass: "btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-icon",
                        attrs: { type: "button" },
                        on: { click: _vm.handleShare },
                      },
                      [_c("i", { staticClass: "go-icon-share go-icon-20" })]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _c("div", { staticClass: "go-card-media" }, [
        _c("div", { staticClass: "go-card-img" }, [
          _c("img", {
            attrs: { src: _vm.imgSource(), alt: "" },
            on: { error: _vm.onErrorImage },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-card-body" }, [
          _c(
            "a",
            { staticClass: "go-card-title", on: { click: _vm.gotoDetail } },
            [_vm._v(_vm._s(_vm.report.title))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "go-card-desc" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.report.description || _vm.report.content) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-card-info", staticStyle: { display: "flex" } },
            [
              _c("div", { staticClass: "source" }, [
                _c("div", { staticClass: "source-img" }, [
                  _vm.report.favicon_url || _vm.report.favicon_base64
                    ? _c("img", {
                        attrs: {
                          src: _vm.report.favicon_url
                            ? _vm.report.favicon_url
                            : _vm.report.favicon_base64,
                        },
                        on: {
                          error: function ($event) {
                            _vm.report.url && _vm.report.url.startsWith("http")
                              ? (_vm.report.favicon_url =
                                  "https://www.google.com/s2/favicons?domain=" +
                                  _vm.report.url)
                              : (_vm.report.favicon_url =
                                  "/content/images/icon-resources-web.png")
                          },
                        },
                      })
                    : _vm.report.url && _vm.report.url.startsWith("http")
                    ? _c("img", {
                        attrs: {
                          src:
                            "https://www.google.com/s2/favicons?domain=" +
                            _vm.report.url,
                        },
                        on: {
                          error: function ($event) {
                            _vm.report.favicon_url =
                              "/content/images/icon-resources-web.png"
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.report.writer || _vm.report.url
                ? _c("div", { staticClass: "source-text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.ExtractHostname(_vm.report.url, _vm.report.writer)
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.isEdit
          ? _c(
              "button",
              {
                staticClass: "btn btn-edit-check active",
                attrs: { type: "button", "data-toggle": "button" },
                on: {
                  click: function ($event) {
                    return _vm.handleSelectReport(_vm.report)
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-check go-icon-18" })]
            )
          : _c("span", { staticClass: "go-badge go-badge-new" }, [
              _vm._v(" NEW "),
            ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "source" }, [
      _c("div", { staticClass: "source-img" }, [
        _c("img", {
          attrs: {
            src: "https://www.google.com/s2/favicons?domain=https://goover.ai/",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "source-text" }, [_vm._v("Goover")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }